export default "__VITE_ASSET__DGzj6Nes__"